// removed by extract-text-webpack-plugin
module.exports = {"person":"GFdCt9H1f5itJ41lfq_rm","intro":"iflocNkftI671mXeuNjTq","photos":"_19rhViZ8-dFjS2cEdwrM0M"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/OurTeam/OurTeam.scss
// module id = 879
// module chunks = 0